/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "atlasCasinoApi",
            "endpoint": "https://fstm0zw9nl.execute-api.eu-west-2.amazonaws.com/play",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:ee648b26-be00-4c84-b70d-c83901dc4641",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_nyvaUaR8U",
    "aws_user_pools_web_client_id": "i72fidkbtjv4hktfgbmm0tnq6",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_dynamodb_all_tables_region": "eu-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "AtlasCasinoTable-play"
        }
    ]
};


export default awsmobile;
